const visibleClass = "is-revealed";

export function initializeScrollAnimations() {
  const elements = [...document.querySelectorAll("[data-reveal]")];

  if (elements.length === 0) return;

  document.querySelectorAll("[data-reveal-group]").forEach((group) => {
    group.querySelectorAll(":scope > [data-reveal]").forEach((element, index) => {
      element.style.setProperty("--reveal-delay", `${Math.min(index, 4) * 90}ms`);
    });
  });

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (reducedMotion.matches || !("IntersectionObserver" in window)) {
    elements.forEach((element) => element.classList.add(visibleClass));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add(visibleClass);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px",
      threshold: 0.08,
    },
  );

  elements.forEach((element) => observer.observe(element));
}
